import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DuplicateCreateApi } from '../../apis/duplicate-create-api';
import type { DuplicateCreateRepository } from '../../services/share-tools-repository';
import type { ShareAuthCheckData } from '../../types';

@injectable()
export class DuplicateCreateRepositoryImpl implements DuplicateCreateRepository {
    constructor(
        @inject(DuplicateCreateApi) private duplicateCreateApi: DuplicateCreateApi
    ) {
    }

    createShareTask(data: ShareAuthCheckData) {
        return this.duplicateCreateApi.createShareTask(data);
    }
}
